// 国际化数据请求在 LangSelect.vue 组件

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elEn from 'element-ui/lib/locale/lang/en' // element-ui lang
import elZhCn from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import elKo from 'element-ui/lib/locale/lang/ko'// element-ui lang
import elJa from 'element-ui/lib/locale/lang/ja'// element-ui lang
import elDe from 'element-ui/lib/locale/lang/de'// element-ui lang
import elFr from 'element-ui/lib/locale/lang/fr'// element-ui lang

import myEn1 from './myEn1'

import { getQueryObject } from '@/utils'


Vue.use(VueI18n)

const messages = {
  zh_CN: { // 简体中文
    ...elZhCn
  },
  zh_HK: {// 繁体中文
    ...elZhCn
  },
  en: {// 英文
    ...elEn,
    ...myEn1
  },
  ko: {// 韩语
    ...elKo
  },
  ja: {// 日文
    ...elJa
  },
  de: {// 德语
    ...elDe
  },
  fr: {// 法语
    ...elFr
  }
}
export function getLanguage() {
  const query = getQueryObject();
  console.log(query)
  if (query && query.lang) return query.lang

  const lang = Cookies.get('language')
  console.log(lang)
  if (lang && lang != 'undefined' && lang != '{}') return lang

  let uu = navigator.language || navigator.browserLanguage;
  uu = uu.replace('-', '_')
  console.log(uu)
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (uu.indexOf(locale) > -1) {
      return locale
    }
  }
  return 'en'
}

const current = getLanguage();
console.log('当前语言：', current)

const i18n = new VueI18n({
  locale: current,
  fallbackLocale: 'en',
  messages
})

export default i18n
